"use client"

import { CollectionFloorPriceChangePeriod } from "@anaconda/core/nft-collection/collection/types"
import { Trans } from "@lingui/react/macro"
import {
  ToggleGroup,
  ToggleGroupItem,
} from "@rarible_int/anaconda_ui_components"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { FloorPriceChartMoleculeReatom } from "./floor-price-chart-molecule.reatom"

const PERIODS = [
  { value: CollectionFloorPriceChangePeriod.HOUR, label: <Trans>1h</Trans> },
  { value: CollectionFloorPriceChangePeriod.DAY, label: <Trans>1d</Trans> },
  { value: CollectionFloorPriceChangePeriod.WEEK, label: <Trans>1w</Trans> },
  { value: CollectionFloorPriceChangePeriod.MONTH, label: <Trans>1m</Trans> },
  {
    value: CollectionFloorPriceChangePeriod.HALF_YEAR,
    label: <Trans>6m</Trans>,
  },
  { value: CollectionFloorPriceChangePeriod.YEAR, label: <Trans>1y</Trans> },
]

export const ChartPeriodSelectorReatom = reatomComponent(() => {
  const { periodAtom, setPeriod } = useMolecule(FloorPriceChartMoleculeReatom)
  const period = periodAtom()

  return (
    <ToggleGroup
      className="justify-start border-none p-1"
      type="single"
      value={period}
      onValueChange={setPeriod}
      data-testid="chart-period-selector"
    >
      {PERIODS.map(({ value, label }) => (
        <ToggleGroupItem key={value} value={value} className="h-7 p-x-3">
          {label}
        </ToggleGroupItem>
      ))}
    </ToggleGroup>
  )
})
